import React from "react";

function getFontSize( text, max_chars, currentFontSize = 50 )
{
	// Skalierungsfaktor berechnen
	const emFontSize = text !== null ? max_chars / text.length : 0;
	return emFontSize < 1 ? emFontSize * currentFontSize : currentFontSize;
	
} // getFontSize(...)

const Logo = ( props ) =>
{
	const { topText = "", bottomText = "", className, id = "" } = props;
	
	return <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 500 500">
		<g className={className}>
			<path fill="#007FAD" d="M425.035,251.298c0.24,44.906-16.972,89.896-51.687,124.162c-68.941,68.061-180.728,68.063-249.667,0.002
                                   c-26.239-25.901-42.458-57.938-48.708-91.437l-39.375-33.246L0.522,290.363C8.393,340.539,31.88,388.78,71.034,427.43
                                   c98.022,96.759,256.951,96.763,354.966-0.002c50.114-49.473,75.125-114.654,74-179.49l-36.944,38.182"/>
			<path fill="#414042" d="M74.618,250.464c-0.241-45.225,17.006-90.532,51.79-125.042c69.086-68.545,181.099-68.546,250.181-0.001
	                               c26.293,26.085,42.546,58.349,48.809,92.087l39.455,33.484L500,211.121c-7.886-50.529-31.421-99.113-70.653-138.038
	                               c-98.229-97.443-257.48-97.446-355.698,0.004C23.428,122.913-1.128,188.557,0,253.851l36.517-38.451"/>
			<path d="M215.101,305.98l0.012,25.001c-44.267,4.236-83.59-28.148-87.833-72.335c-4.244-44.185,28.203-83.436,72.469-87.672
                   c5.086-0.486,10.208-0.487,15.294-0.006l0.011,25c-29.056-3.871-56.406,15.578-61.931,44.674
                   c-5.718,30.111,14.102,59.146,44.27,64.855C203.398,306.636,209.356,306.744,215.101,305.98z M352.381,306.418
                   c-5.907,0.845-12.048,0.591-18.242-0.581c-22.903-4.333-39.827-22.131-44.155-43.947h45.912V238.71h-45.395
                   c6.754-27.269,33.476-45.854,61.718-41.876l-0.036-25.729c-5.604-0.581-11.254-0.605-16.853-0.009
                   c-44.22,4.711-76.237,44.294-71.521,88.431c4.724,44.135,44.392,76.09,88.609,71.377L352.381,306.418z"/>
			
			<defs>
				<path id={`textTop${id}`} d="M62.75,196.132c23.95-82.24,99.659-142.314,189.352-142.314c89.688,0,165.395,60.073,189.347,142.312"/>
				<path id={`textBottom${id}`} d="M20.696,300.37c22.169,102.398,116.047,179.298,228.493,179.298 c112.814,0,206.939-77.405,228.707-180.309"/>
			</defs>
			
			<use xlinkHref={`#textTop${id}`} fill="none" stroke="none"/>
			<use xlinkHref={`#textBottom${id}`} fill="none" stroke="none"/>
			
			<text fontFamily="Exo2-Light" fontSize={getFontSize( topText, 20 )} letterSpacing={2} textAnchor="middle" fill="#FFFFFF">
				<textPath xlinkHref={`#textTop${id}`} startOffset="50%">
					{topText}
				</textPath>
			</text>
			
			<text fontFamily="Exo2-Light" fontSize={getFontSize( bottomText, 20 )} letterSpacing={4} textAnchor="middle" fill="#FFFFFF">
				<textPath xlinkHref={`#textBottom${id}`} startOffset="50%">
					{bottomText}
				</textPath>
			</text>
		</g>
	</svg>;
	
}; // function Logo()

export default Logo;